/**
 * Copyright © 2026 Adnuntius AS.
 */

/** Duplicate name suffixes the app adds: space + `(copy)` or `(copy #n)`. */
const COPY_SEGMENT = / \(copy(?: #(\d+))?\)/g;

/**
 * Next suggested name when duplicating: appends ` (copy)`, or ` (copy #n)` after
 * removing prior markers. Each ` (copy)` counts as one generation; each ` (copy #k)`
 * counts as k. Generations sum so `Foo (copy) (copy)` becomes `Foo (copy #3)`.
 */
export function nextCopyTitle(name: string | null | undefined): string {
  const s = name === null || name === undefined ? '' : String(name);
  let depth = 0;
  const re = new RegExp(COPY_SEGMENT.source, 'g');
  let m: RegExpExecArray | null;
  while ((m = re.exec(s)) !== null) {
    depth += m[1] !== undefined ? parseInt(m[1], 10) : 1;
  }
  const base = s
    .replace(/ \(copy(?: #(\d+))?\)/g, '')
    .replace(/  +/g, ' ')
    .trimEnd();
  if (depth === 0) {
    return `${base} (copy)`;
  }
  return `${base} (copy #${depth + 1})`;
}
